export const TAX_CONFIG_PATH = "/configuration/tax-configuration";
export const ZATCA_INVOICES_PATH = "/zatca/invoices";

/** Menu paths shown only when ZATCA app is purchased. */
export const ZATCA_MENU_PATHS = [TAX_CONFIG_PATH, "/configuration/zatca-settings", ZATCA_INVOICES_PATH];

/** Legacy stored value — treated as ZATCA Phase 2. */
export const LEGACY_ZATCA_TYPE = "zatca";

export const TAXATION_TYPES = {
  SIMPLE: "simple",
  ZATCA_PHASE_1: "zatca_phase_1",
  ZATCA_PHASE_2: "zatca_phase_2",
};

export function getDefaultTaxConfiguration() {
  return {
    taxationEnabled: true,
    taxationType: TAXATION_TYPES.ZATCA_PHASE_2,
  };
}

function getStorageKey(tenantId) {
  return `hulm_tax_config_${tenantId || "default"}`;
}

export function loadTaxConfiguration(tenantId) {
  if (!tenantId) return getDefaultTaxConfiguration();

  try {
    const raw = localStorage.getItem(getStorageKey(tenantId));
    if (!raw) return getDefaultTaxConfiguration();

    const parsed = JSON.parse(raw);
    return normalizeTaxConfiguration(parsed);
  } catch {
    return getDefaultTaxConfiguration();
  }
}

export function resolveTaxationType(value) {
  if (value === TAXATION_TYPES.SIMPLE) return TAXATION_TYPES.SIMPLE;
  if (value === TAXATION_TYPES.ZATCA_PHASE_1) return TAXATION_TYPES.ZATCA_PHASE_1;
  if (value === TAXATION_TYPES.ZATCA_PHASE_2 || value === LEGACY_ZATCA_TYPE) {
    return TAXATION_TYPES.ZATCA_PHASE_2;
  }
  return TAXATION_TYPES.ZATCA_PHASE_2;
}

export function isZatcaTaxationType(taxationType) {
  const resolved = resolveTaxationType(taxationType);
  return (
    resolved === TAXATION_TYPES.ZATCA_PHASE_1 ||
    resolved === TAXATION_TYPES.ZATCA_PHASE_2
  );
}

export function getZatcaPhaseFromTaxConfig(taxConfig) {
  const config = normalizeTaxConfiguration(taxConfig);
  if (!config.taxationEnabled) return null;
  if (config.taxationType === TAXATION_TYPES.ZATCA_PHASE_1) return 1;
  if (config.taxationType === TAXATION_TYPES.ZATCA_PHASE_2) return 2;
  return null;
}

export function normalizeTaxConfiguration(config) {
  const defaults = getDefaultTaxConfiguration();
  if (!config || typeof config !== "object") return defaults;

  return {
    taxationEnabled: config.taxationEnabled !== false,
    taxationType: resolveTaxationType(config.taxationType),
  };
}

export function saveTaxConfiguration(tenantId, config) {
  const normalized = normalizeTaxConfiguration(config);
  localStorage.setItem(getStorageKey(tenantId), JSON.stringify(normalized));
  return normalized;
}
